import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState('default'); // Always start with default
  const [isInitialized, setIsInitialized] = useState(false);

  const themes = {
    default: {
      name: 'Default',
      description: 'Classic green terminal theme'
    },
    lolo: {
      name: 'Lolo',
      description: 'The woman who made all of this possible, you are my life 💜'
    }
  };

  const setTheme = (themeName) => {
    console.log('setTheme called with:', themeName);
    if (themes[themeName]) {
      setCurrentTheme(themeName);
      // Don't save to localStorage anymore - theme should reset on each visit
      
      // Apply theme class to body
      document.body.className = document.body.className.replace(/theme-\w+/g, '');
      if (themeName !== 'default') {
        document.body.classList.add(`theme-${themeName}`);
      }
      console.log('Theme applied successfully to body:', document.body.className);
    } else {
      console.log('Theme not found in themes object:', themeName, themes);
    }
  };

  useEffect(() => {
    // Always start fresh with default theme - clear any existing theme classes
    document.body.className = document.body.className.replace(/theme-\w+/g, '');
    
    // Mark as initialized
    setIsInitialized(true);
    console.log('ThemeProvider fully initialized with default theme');
  }, []);

  const value = {
    currentTheme,
    themes,
    setTheme,
    isInitialized,
    getThemeClass: () => currentTheme === 'default' ? '' : `theme-${currentTheme}`
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}; 